/**
 * Render Info paragraphs with **bold** markers.
 */
export function InfoParagraphs({ paragraphs }) {
  if (!Array.isArray(paragraphs) || !paragraphs.length) return null;
  return (
    <div className="space-y-3">
      {paragraphs.map((text, i) => (
        <p key={i}>{renderBoldParts(String(text || ''))}</p>
      ))}
    </div>
  );
}

function renderBoldParts(text) {
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**') && part.length > 4) {
      return <strong key={i}>{part.slice(2, -2)}</strong>;
    }
    return <span key={i}>{part}</span>;
  });
}
